import React from "react";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {Objects} from "components";

class AltruPayTerminals extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Terminals_Altrupay._name, API.RequestType.READ_ALL);
		super(props, model);
		this.fetchData();
	}

	deleteTerminalFromStripe = () => {
		let aModel = new API.BuildClass(Types.Terminals._name, 'POST_TERMINAL_STRIPE_ALTRUPAY_REMOVE');
		aModel.submit(this, 'POST_TERMINAL_STRIPE_ALTRUPAY_REMOVE');
	}


	render() {
		const {data, loading} = this.state;

		const isTacticalPay = window.isTacticalPay;

		const settingTab = isTacticalPay ? '/settings#tacticalpay' : '/settings#altrupay';

		return (
			<div className={'form-group'}>
				<Button onClick={() => this.setState({modalAddTerminal: true})}
				        variant="contained"
				        className="primary-button"
				>
					Add Terminal
				</Button>
				<div className={'row'}>
					{data?.map((item) =>
						<div className={'col-6'}>
							<Objects.AltrupaySpinProcessor
								id={item.pkey}
								account={this.props.account}
								afterDelete={() => {
									this.deleteTerminalFromStripe();
									//reload the tab
									this.props.history.push('/');
									this.props.history.push(settingTab);
								}}
							/>
						</div>
					)}
				</div>
				{APPCONFIG.settings.isDev() ? null :
					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				}
				<Framework.Elements.UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					title={isTacticalPay ? "New TacticalPay Terminal" : "New AltruPay Terminal"}
					objectProps={{
						terminal_amount: data.length
					}}
					object={Objects.AltrupaySpinProcessor}
					history={this.props.history}
					toggle={this.state.modalAddTerminal}
					reportClose={() => {
						this.setState({modalAddTerminal: false})
					}}
					size={'lg'}
					hideGoTo={true}
					project={'pos'}
				/>
			</div>

		)
	}
}

export default Framework.Components.withRootState(AltruPayTerminals);
